import React from "react";

import { Group, Select } from "@mantine/core";
import { useHistory } from "react-router-dom";
import { CreateNewButton } from "../../../../components";
import { useAppSelector } from "../../../../hooks";
import { sortArrayByDate } from "../../../utils";
import { formatShortDate } from "../../admin/selectors";
import { ConnectedMeetingOption, MeetingDetails, toMeetingSerieOption } from "../meetingApiTypes";
import NewMeetingInSeriesModal from "../NewMeetingInSeriesModal";

const MeetingSeriesInstanceSelector: React.FC<{ singleMeeting: MeetingDetails }> = ({ singleMeeting }) => {
  const meetingSerie = toMeetingSerieOption(singleMeeting?.meetingSerie);
  const [newMeetingModalOpen, setNewMeetingModalOpen] = React.useState<boolean>(false);

  const project = useAppSelector((state) => state.adminReducer.project);

  const history = useHistory();
  const onChange = (_oldDate: MeetingDetails, meetingObj: ConnectedMeetingOption) => {
    history.replace(`/project/${project._id}/meetings/${meetingObj._id}`);
  };

  const connectedMeetings: ConnectedMeetingOption[] =
    typeof singleMeeting?.meetingSerie === "object" &&
    singleMeeting.meetingSerie != null &&
    "connectedMeetingInstances" in singleMeeting.meetingSerie
      ? (singleMeeting.meetingSerie.connectedMeetingInstances ?? []).filter(
          (meeting): meeting is ConnectedMeetingOption =>
            typeof meeting === "object" &&
            meeting != null &&
            ("dateOfMeeting" in meeting || "isDeleted" in meeting) &&
            meeting.isDeleted !== true,
        )
      : [];

  const meetingOptions = sortArrayByDate(connectedMeetings, "dateOfMeeting").map((m) => ({
    value: m._id,
    label: formatShortDate(m.dateOfMeeting?.toString()),
  }));

  return (
    <Group gap="xs">
      <NewMeetingInSeriesModal
        meetingSerie={meetingSerie}
        opened={newMeetingModalOpen}
        onClose={() => setNewMeetingModalOpen(false)}
      />
      <Select
        size="sm"
        value={singleMeeting._id}
        data={meetingOptions}
        onChange={(val) => {
          const target = connectedMeetings.find((m) => m._id === val);
          if (target) {
            onChange(singleMeeting, target);
          }
        }}
        allowDeselect={false}
        w={140}
      />
      <CreateNewButton onClick={() => setNewMeetingModalOpen(true)} tooltip="Legg til nytt møte" size="sm" />
    </Group>
  );
};

export default MeetingSeriesInstanceSelector;
